import { render, staticRenderFns } from "./FlowDetail.vue?vue&type=template&id=171764e7&scoped=true&"
import script from "./FlowDetail.vue?vue&type=script&lang=js&"
export * from "./FlowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171764e7",
  null
  
)

export default component.exports